import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'water_intake'

const answers: AnswerType[] = [
  {
    emoji: '💧',
    title: 'pages.onboarding.waterIntake.options.tenPlus',
    value: '10+',
  },
  {
    emoji: '💦',
    title: 'pages.onboarding.waterIntake.options.sixToNine',
    value: '6-9',
  },
  {
    emoji: '🥤',
    title: 'pages.onboarding.waterIntake.options.twoToFive',
    value: '2-5',
  },
  {
    emoji: '🥵',
    title: 'pages.onboarding.waterIntake.options.lessThanOne',
    value: 'less-than-1',
  },
]

export default function WaterIntakePage() {
  const [searchParams] = useSearchParams()
  const urlValue = searchParams.get('value')
  const preselectedValue =
    urlValue && answers.some((a) => a.value === urlValue) ? urlValue : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How much water do you drink in a day?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.waterIntake.heading"
      subtitle="pages.onboarding.waterIntake.description"
      preselectedValue={preselectedValue}
      onSubmit={onSubmit}
    />
  )
}
